<template>
  <div class="logo">
    <div v-if="!$store.state.isMobile">
      <div class="bgc" :style="$store.state.themeData.pcBg ? `background: url(${$store.state.themeData.pcBg}) 0 0/cover no-repeat;` : ''"></div>
      <div class="logoContent" :style="$store.state.themeData.pcBg ? 'margin-left: 28vw' : ''">
        <div class="title" v-if="contentType != 4">{{contentTitle[contentType]}}</div>
        <div v-else>
          <div class="name">{{$store.state.museumName}}</div>
          <div :class="{
            'status': true,
            'status_g': $store.state.ticketDetail.currentState == '正常开放',
            'status_r': $store.state.ticketDetail.status == 0,
            'status_y': $store.state.ticketDetail.status == 2
          }">{{$store.state.ticketDetail.currentState == '闭馆' ? '今日闭馆' : $store.state.ticketDetail.currentState}}</div>
          <div class="timeAndDate">开馆时间：{{$store.state.ticketDetail.timeOpen}}&nbsp;&nbsp;停止入馆时间：{{$store.state.ticketDetail.timeStop}}<br/><span v-if="$store.state.ticketDetail.maxLimit">预约上限：{{$store.state.ticketDetail.maxLimit}}人/天</span></div>
        </div>
        <slot name="resetIndex"></slot>
        <slot name="inputs"></slot>
        <div class="bottomWarp">
          <div class="button">
            <slot name="button"></slot>
          </div>
          <div class="erCode">
            <div id="qrCode" ref="qrcode"></div>
            <div>扫码前往移动端</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="h5" :style="$store.state.themeData.h5Bg ? 'padding-top: 0' : ''">
      <div :class="`bgc ${$route.query.museumCode == 218425 ? 'jxhy' : ''}`" :style="$store.state.themeData.h5Bg ? `background: url(${$store.state.themeData.h5Bg}) 0 0/cover no-repeat;` : ''"></div>
      <div class="loginContent">
        <div class="title">{{contentTitle[contentType]}}</div>
        <slot name="resetIndex"></slot>
        <slot name="inputs"></slot>
        <slot name="button"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      ticketDetail: {
        name: '超星博物馆',
        status: 1,
        startTime: '9:00 - 17:00',
        endTime: '16:30',
        maxNum: 5000,
      },
      statusText: ['停业', '开放', '约满'],
      contentTitle: {
        1: '密码登录',
        2: '重置密码',
        3: '新用户注册',
        4: '快捷登录'
      }
    };
  },

  props: ['contentType'],

  methods: {
    getticketDetail() {
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$route.query.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax.get(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
      })
    },

    getMuseum() {
      this.$ajax(`/api/admin/front/group/name?museumCode=${this.$route.query.museumCode}`).then((res) => {
        this.$store.state.museumName = res.data || this.$store.state.ticketDetail.ticketName
      })
    },

    setErCode() {
      let text = `${location.origin}${location.pathname}#/ticket/login?museumCode=${this.$route.query.museumCode}`;
      new QRCode(this.$refs.qrcode, {
        text: text, //页面地址 ,如果页面需要参数传递请注意哈希模式#
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      })
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.setErCode()
    })
  },
  created() {
    this.$store.state.museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode
    
    if (!this.$store.state.ticketDetail.id) {
      this.getticketDetail()
    }
    this.getMuseum()
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.logo{
  .title{
    font-size: 0.18rem;
    font-weight: bold;
  }
  .bgc{
    height: 100vh;
    width: 30vw;
    background: url('~@/assets/ticket/login1.png') 0 0/100% 100% no-repeat;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .logoContent{
    // margin: 8% 0 0 35%;
    margin-left: 30vw;
    padding: 11vh 0 0 5vw;
    height: 89vh;
    width: 63vw;
    position: relative;
    border-radius: 0.2rem;
    background-color: #fff;
    .name{
      font-size: 0.25rem;
      font-weight: 500;
      color: #333;
    }
    .openStatus{

    }
    .status{
      width: 0.5rem;
      border-radius: 0.25rem;
      font-size: 0.1rem;
      line-height: 0.2rem;
      color: #fff;
      margin: 0.1rem auto;
      background: #e09a19;
    }
    .status_g{
      background-color: #7fa704;
    }
    .status_r{
      background-color: red;
    }
    .status_y{
      background-color: yellow;
    }
    .timeAndDate{
      font-size: 0.1rem;
      margin: 0.2rem 0;
    }
    .inputPhone, .inputCode{
      width: 3.5rem;
      margin:auto;
      position: relative;
    }
    .inputPhone::before{
      display: inline-block;
      content: '';
      height: 0.2rem;
      width: 0.1rem;
      // background: url('~@/assets/ticket/icon_phone.png') 0 0/100% no-repeat;
      position: absolute;
      top: 0.2rem;
      left: 0.4rem;
      z-index: 222;
    }
    .inputCode::before{
      display: inline-block;
      content: '';
      height: 0.2rem;
      width: 0.1rem;
      // background: url('~@/assets/ticket/icon_password.png') 0 0/100% no-repeat;
      position: absolute;
      top: 0.2rem;
      left: 0.4rem;
      z-index: 222;
    }
    .button1{
      position: absolute;
      top: 0.17rem;
      right: 0.4rem;
    }
    .bottomWarp{
      position: relative;
    }
    .button{
      margin-top: 0.5rem;
      margin-left: 1.7rem;
      min-height: 0.5rem;
    }
    .erCode{
      font-size: 0.08rem;
      position: absolute;
      bottom: -0.2rem;
      right: 1.6rem;
    }
    #qrCode{
      width: 0.6rem;
      height: 0.6rem;
      display: inline-block;
    }
  }
  .h5{
    min-height: 100vh;
    background-color: #eaebea;
    padding-top: 1rem;
    .title{
      font-weight: bold;
      font-size: 0.6rem;
    }
    .bgc{
      width: 100vw;
      background: url('~@/assets/ticket/loginBg.png') 0 0/100% no-repeat;
      position: static;
      height: calc(50vh - 3rem);
    }
    .jxhy{
      background: url('~@/assets/ticket/jxhy_bg.png') 0 0/cover no-repeat;
      margin-top: -1rem;
    }
    .loginContent{
      position: fixed;
      top: calc(50vh - 4rem);
      width: 9rem;
      margin: 0 0.2rem;
      padding: 0.3rem;
      background-color: #fff;
      border-radius: 0.5rem;
    }
  }
}
</style>
<style type="text/css">
  .logoContent .el-input__inner{
    width: 3rem;
    margin: 0.1rem;
    padding: 0.05rem 0.4rem;
    padding-right: 1rem;
    background-color: #f6f6f6;
    height: 0.35rem;
    border: unset;
  }
  .inputCode .el-input__inner{
    /*width: 2rem;*/
    /*padding-right: ;*/
  }
  .loginContent .el-input__inner{
    margin: 0.3rem 0;
    height: 1.2rem;
    width: 8rem;
    border-radius: 0.6rem;
    font-size: 0.4rem;
    line-height: 1.2rem;
  }

  .logoContent .bottomWarp #qrCode img{
    width: 100%;
    height: 100%;
  }
</style>
